export enum UserRegistrationStatus {
  Available = 0,
  EmailRegisteredByUser = 1,
  EmailRegisteredByCentralContact = 2
  }